import i18n from 'i18n';
import {
  ITooltipParams,
  ValueFormatterParams,
} from '@ag-grid-community/core';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import GridGroupHeader from 'components/GridGroupHeader';

export enum XdpMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const xdtpXdpConnectionAutoGroupColumnDef: ColDef = {
  headerName: i18n.t('xtpXdpConnection.grid.name'),
  sortable: true,
  floatingFilter: true,
  filter: 'agTextColumnFilter',
  resizable: true,
  flex: 1,
  minWidth: 170,
  headerComponent: GridGroupHeader as any,
  filterValueGetter: (params: Partial<ValueFormatterParams>): string => {
    return params.data?.name;
  },
};

export const xdtpXdpConnectionColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('xtpXdpConnection.grid.name'),
    field: 'name',
    rowGroup: true,
    hide: true,
    lockVisible: true,
    floatingFilter: true,
  },
  {
    headerName: i18n.t('xtpXdpConnection.grid.ipduid'),
    field: 'ipduid',
    tooltipField: 'ipduid',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    flex: 1,
    minWidth: 170,
    aggFunc: 'first',
    tooltipValueGetter: (params: Partial<ITooltipParams>): string => {
      if (params.node?.group) {
        return params?.value;
      }

      return '';
    },
    cellRenderer: (params: Partial<ValueFormatterParams>): string => {
      if (params.node?.group) {
        return params?.value;
      }

      return '';
    },
  },
  {
    headerName: i18n.t('xtpXdpConnection.grid.lbid'),
    field: 'lbid',
    tooltipField: 'lbid',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    flex: 1,
    minWidth: 170,
    aggFunc: 'first',
    tooltipValueGetter: (params: Partial<ITooltipParams>): string => {
      if (params.node?.group) {
        return params?.value;
      }

      return '';
    },
    cellRenderer: (params: Partial<ValueFormatterParams>): string => {
      if (params.node?.group) {
        return params?.value;
      }

      return '';
    },
  },
  {
    headerName: i18n.t('xtpXdpConnection.grid.type'),
    field: 'type',
    tooltipField: 'type',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    flex: 1,
    minWidth: 170,
  },
  {
    headerName: i18n.t('xtpXdpConnection.grid.destPort'),
    field: 'destPort',
    tooltipField: 'destPort',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    flex: 1,
    minWidth: 170,
  },
];

export const CONNECTION_PROTOCOLS_TYPES = {
  axs: 'AXS',
  axsgp: 'AXSGP',
  etsiip: 'ETSIIP'
}

export const defaultProtocolPorts = {
  [CONNECTION_PROTOCOLS_TYPES.axs]: '45014',
  [CONNECTION_PROTOCOLS_TYPES.axsgp]: '45086',
  [CONNECTION_PROTOCOLS_TYPES.etsiip]: '45116'
}
